import React from 'react';

import DependencyConsumer from '../components/DependencyConsumer';
import ListenState from '../components/ListenState';

export const withDependency = (name, property = name) => Component => props => (
  <DependencyConsumer name={name}>
    {service => <Component {...props} {...{ [property]: service }} />}
  </DependencyConsumer>
);

export const defControllerView = (name, property = name) => Component => props => (
  <DependencyConsumer name={name}>
    {controller => (
      <ListenState state={controller.getState()}>
        {state =>
          <Component
            {...props}
            {...{ [property]: controller }}
            data={state}
          />
        }
      </ListenState>
    )}
  </DependencyConsumer>
);



// WEBPACK FOOTER //
// ./src/utils/withDependency.js